import { z } from 'zod';

/**
 * Get default values from Zod schema. Useful for form initial values.
 *
 * @see https://github.com/colinhacks/zod/discussions/1953#discussioncomment-4811588
 *
 * @param schema
 * @returns Object with each schema property's default value or undefined if not defined in the schema.
 */
export function getDefaults<Schema extends z.AnyZodObject | z.ZodEffects<z.AnyZodObject>>(
    schema: Schema
): { [k: string]: unknown } {
    const shape = schema instanceof z.ZodEffects ? schema._def.schema.shape : schema.shape;

    return Object.fromEntries(
        Object.entries(shape).map(([key, value]) => {
            if (value instanceof z.ZodDefault) {
                return [key, value._def.defaultValue()];
            }
            if (value instanceof z.ZodEffects) {
                if (value._def.schema instanceof z.ZodObject) {
                    return [key, getDefaults(value._def.schema)];
                }
            }
            if (value instanceof z.ZodObject) {
                return [key, getDefaults(value)];
            }
            return [key, undefined];
        })
    );
}
